// extracted by mini-css-extract-plugin
export default {"card":"CardAnswer_card__erM6D","selected":"CardAnswer_selected__hXYQu"};